module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-right-33dcbafe7b58d96ac6c0d083cc82bbca.svg";